const SDK_VERSION = '7.23.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
